angular.module('vastdesk').
  component('scannedCreativeAssetPreviews',  {
    bindings: {
      videoPlayerId: '@',
      audioPlayerId: '@',
      assetId: '@',
      assetUrl: '@',
      screenshotUrl: '@',
      mimeType: '@',
      assetOptions: '<'
    },
    template: require("../templates/scannedCreativeAssetPreviews.html"),
    controllerAs: '$scannedCreativeAssetPreviewsCtrl',
    controller: ['$rootScope', function($rootScope) {

      var self = this;

      this.assetChange = function() {
        var selectedAsset = _.find(self.assetOptions, function(ao) {
          return ao[1] === self.assetId;
        });

        self.assetId = selectedAsset[1];
        self.assetUrl = selectedAsset[2];
        self.screenshotUrl = selectedAsset[3];
        self.mimeType = selectedAsset[4];

        if (self.isVideo()) {
          $rootScope.$broadcast('videoChange', {
            playerId: self.videoPlayerId,
            src: selectedAsset[2],
            poster: selectedAsset[3]
          });
        }

        if (self.isAudio()) {
          $rootScope.$broadcast('audioChange', {
            playerId: self.audioPlayerId,
            src: selectedAsset[2]
          });
        }
      };

      this.isVideo = function() {
        return self.mimeType.startsWith('video');
      };

      this.isImage = function() {
        return self.mimeType.startsWith('image');
      };

      this.isAudio = function() {
        return self.mimeType.startsWith('audio');
      };
    }]
});
